import Swiper from 'swiper';
import 'regenerator-runtime/runtime';
import './plugins/accordion.plugin';
import './plugins/dropdown.plugin';
import './plugins/mobileNavigation.plugin';
import './plugins/stickyElement.plugin';
import './plugins/stickyHeader.plugin';
import './plugins/tabs.plugin';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import "bootstrap";


$(() => {
    //move page down for fixed header
    $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())

    $(window).on( 'resize orientationchange load', function() {
        $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())
    });

    // mobile menu open subnav
    $('.nav-link.-hasDropdown').on('click', function(e) {
        if ($(window).width() <= 1023) {
            if (!$(this).hasClass('-clickable')) {
                e.preventDefault()
                $('.-subnavOpen').removeClass('-subnavOpen')
                $(this).parent().addClass('-subnavOpen')
                // $(this).parent('li').siblings('.menu-item-has-children').children('.-clickable').removeClass('-clickable')
                $('.-clickable').removeClass('-clickable')
                $(this).addClass('-clickable')
            }
        }
    });

    $(window).scroll(function(){
        if ($(window).scrollTop() > 10){
            $('nav.navbar').addClass('-scrolled')
        } else if ( $('nav.navbar').hasClass('-scrolled') ) {
            $('nav.navbar').removeClass('-scrolled')
            setTimeout( function() {
                $('main[role=main]').css('padding-top', $('nav.navbar').outerHeight())
            }, 300);
        }
    })



    //hero video settings
    if( $( '.hero video' ).length ) {
        var vid = $( '.hero video' );
        if (window.matchMedia('(prefers-reduced-motion)').matches) {
            vid.removeAttribute("autoplay");
            vid.pause();
        }
    }


    // make pdfs open in new window
    $('a[href$=".pdf"], a[href$=".PDF"], a[href$=".doc"], a[href$=".DOC"], a[href$=".docx"], a[href$=".DOCX"]').attr('target', '_blank')


    //intialize introduction slider
    if( $( '.introduction-container' ).length ) {
        var introductionSwiper = new Swiper('.introduction-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.introduction-container .swiper-button-next',
                prevEl: '.introduction-container .swiper-button-prev',
            },
            pagination: {
                el: '.introduction-container .swiper-pagination',
                type: 'fraction',
            },
        });
        introductionSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.introduction-container .slider__navigation').hasClass('-dark') && !$('.introduction-container .swiper-slide-active').hasClass('-dark') ) {
                $('.introduction-container .slider__navigation').removeClass('-dark')
            } else if ( $('.introduction-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.introduction-container .slider__navigation').addClass('-dark')
            }
        })
        introductionSwiper.init()
    }

    //intialize twoColumnSlider
    if( $( '.twoColumnSlider-container' ).length ) {
        var twoColumnSwiper = new Swiper('.twoColumnSlider-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.twoColumnSlider-container .swiper-button-next',
                prevEl: '.twoColumnSlider-container .swiper-button-prev',
            },
            pagination: {
                el: '.twoColumnSlider-container .swiper-pagination',
                type: 'fraction',
            },
        });
        twoColumnSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.twoColumnSlider-container .slider__navigation').hasClass('-dark') && !$('.twoColumnSlider-container .swiper-slide-active').hasClass('-dark') ) {
                $('.twoColumnSlider-container .slider__navigation').removeClass('-dark')
            } else if ( $('.twoColumnSlider-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.twoColumnSlider-container .slider__navigation').addClass('-dark')
            }
        })
        twoColumnSwiper.init()
    }

    //intialize imageSlider
    if( $( '.imageSlider-container' ).length ) {
        var imageSwiper = new Swiper('.imageSlider-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.imageSlider-container .swiper-button-next',
                prevEl: '.imageSlider-container .swiper-button-prev',
            },
            pagination: {
                el: '.imageSlider-container .swiper-pagination',
                type: 'fraction',
            },
        });
        imageSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.imageSlider-container .slider__navigation').hasClass('-dark') && !$('.imageSlider-container .swiper-slide-active').hasClass('-dark') ) {
                $('.imageSlider-container .slider__navigation').removeClass('-dark')
            } else if ( $('.imageSlider-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.imageSlider-container .slider__navigation').addClass('-dark')
            }
        })
        imageSwiper.init()
    }

    //intialize testimonial slider
    if( $( '.testimonials-container' ).length ) {
        var testimonialsSwiper = new Swiper('.testimonials-container', {
            init: false,
            loop: true,
            navigation: {
                nextEl: '.testimonials-container .swiper-button-next',
                prevEl: '.testimonials-container .swiper-button-prev',
            },
            pagination: {
                el: '.testimonials-container .swiper-pagination',
                type: 'fraction',
            },
        });
        testimonialsSwiper.on('slideChangeTransitionEnd init', function () {
            if ( $('.testimonials-container .slider__navigation').hasClass('-dark') && !$('.testimonials-container .swiper-slide-active').hasClass('-dark') ) {
                $('.testimonials-container .slider__navigation').removeClass('-dark')
            } else if ( $('.testimonials-container  .swiper-slide-active').hasClass('-dark') ) {
                $('.testimonials-container .slider__navigation').addClass('-dark')
            }
        })
        testimonialsSwiper.init()
    }

    //intialize ModelCarousel slider if more than 3 slides
    if( $( '.js-cardScroller' ).length && $('.js-cardScroller .swiper-slide').length > 3) {
        var cardSlider = new Swiper('.js-cardScroller', {
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                300: {
                    slidesPerView: 1.5,
                    spaceBetween: 48,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 48,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 64,
                }
            },
            simulateTouch: true
        });
    } else if( $( '.js-cardScroller' ).length && $('.js-cardScroller .swiper-slide').length <= 3) {
        $('.js-cardScroller').addClass('-noSlider')
    }

    //intialize ModelCarousel slider if more than 3 slides
    if( $( '.js-cardScroller' ).length && $('.js-cardScroller .swiper-slide').length > 1) {
        var cardSlider = new Swiper('.js-cardScroller', {
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                300: {
                    slidesPerView: 1.5,
                    spaceBetween: 48,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 48,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 64,
                }
            },
            simulateTouch: true
        });
    }

    //intialize gallery slider
    if( $( '.gallery-container' ).length ) {
        var gallerySwiper = new Swiper('.gallery-container', {
            loop: true,
            navigation: {
                nextEl: '.gallery-container + .slider__navigation .swiper-button-next',
                prevEl: '.gallery-container + .slider__navigation .swiper-button-prev',
            },
            pagination: {
                el: '.gallery-container + .slider__navigation .swiper-pagination',
                type: 'fraction',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    centeredSlides: true
                }
            }
        });

        // add nav in modals
        $('.modal-button-prev').on('click', function(){
            prevModal()
        })
        $('.modal-button-next').on('click', function(){
            nextModal()
        })

        $(document).keydown(function(e){
            if (e.which == 37) { 
                e.preventDefault()
                prevModal()
            }
        })

        $(document).keydown(function(e){
            if (e.which == 39) { 
                e.preventDefault()
                nextModal()
            }
        })

        function prevModal() {
            const currentModal = $('.modal.show');
            if ( currentModal.prev('.modal').length ) {
                gallerySwiper.slidePrev()
                currentModal.modal('hide')
                currentModal.prev('.modal').modal('show')
            } else {
                gallerySwiper.slidePrev()
                currentModal.modal('hide')
                currentModal.siblings('.-last').modal('show')
            }
        }

        function nextModal() {
            const currentModal = $('.modal.show');
            if ( currentModal.next('.modal').length ) {
                gallerySwiper.slideNext()
                currentModal.modal('hide')
                currentModal.next('.modal').modal('show')
            } else {
                gallerySwiper.slidePrev()
                currentModal.modal('hide')
                currentModal.siblings('.-first').modal('show')
            }
        }
    }

    // pause video on modal close
    $('[data-toggle="modal"]').on('click', function(){
        // get link's modal target
        var modalTarget = $(this).data('target');

        // if modal has an iframe
        if ( !$(modalTarget).find('iframe').length == 0 ) {

            // get iframe and src
            var modalIframe = $(modalTarget).find('iframe');
            var modalIframeSrc = $(modalIframe).attr('src');

            // set src attribute on close to ensure video stops playing
            $(modalTarget).on('hide.bs.modal', function (e) {
                $(modalIframe).attr('src', modalIframeSrc);
            });

            // set src attribute on open
            $(modalTarget).on('show.bs.modal', function (e) {
                $(modalIframe).attr('src', modalIframeSrc);
            });
        }
    });

    //initialize relatedProducts slider

    if( $( '.relatedProducts-container' ).length && $('.relatedProducts-container .swiper-slide').length > 2) {
        // Calculate and set container width
        const setContainerWidth = () => {
            const container = document.querySelector('.twoColumn__right');
            const swiperWrapper = document.querySelector('.relatedProducts-container .swiper-wrapper');
            if (container && swiperWrapper) {
                const width = container.getBoundingClientRect().width;
                const computedStyle = window.getComputedStyle(container);
                const paddingRight = parseInt(computedStyle.paddingRight, 10);
                const adjustedWidth = width - paddingRight;
                swiperWrapper.style.setProperty('--container-width', `${adjustedWidth}px`);
                // Also set it on the container level just in case
                container.style.setProperty('--container-width', `${adjustedWidth}px`);
            }
        };

        // Set initial width
        setContainerWidth();

        // Update on resize
        window.addEventListener('resize', setContainerWidth);

        var relatedProductsSwiper = new Swiper('.relatedProducts-container', {
            init: false,
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: '.slider__navigation .swiper-button-next',
                prevEl: '.slider__navigation .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                }
            },
            on: {
                init: function () {
                    this.update();
                    setContainerWidth(); // Also set width on init
                },
                resize: function () {
                    this.update();
                    setContainerWidth(); // Also set width on resize
                }
            }
        });
        
        $(document).ready(() => {
            relatedProductsSwiper.init();
        });
    } else if( $( '.relatedProducts-container' ).length && $('.relatedProducts-container .swiper-slide').length <= 2) {
        $('.relatedProducts-container').addClass('-noSlider');
    }

    // Initialize mobile sliders (blogPosts and logoGrid)
    const initializeMobileSlider = (selector) => {
        if ($(selector).length) {
            let swiper;
            
            const initializeSwiper = () => {
                if (window.innerWidth < 768 && !swiper) {
                    swiper = new Swiper(selector, {
                        slidesPerView: 1.25,
                        spaceBetween: 16,
                        grabCursor: true,
                    });
                } else if (window.innerWidth >= 768 && swiper) {
                    swiper.destroy();
                    swiper = undefined;
                }
            };

            // Initialize
            initializeSwiper();

            // Re-initialize on resize
            window.addEventListener('resize', initializeSwiper);
        }
    };

    // Initialize both sliders
    initializeMobileSlider('.blogPosts__grid');
    initializeMobileSlider('.twoColumn__logoGrid');
});